(function () {

    'use strict';

    var CategoryToolbarCmp = {
        bindings: {
            onNewFilters: '&',
            category: '<',
            onUpdateLayout: '&',
            onClickFilter: '&'
        },
        controller: CategoryToolbarCmpCtrl,
        templateUrl: 'category-toolbar.component.html'
    };

    angular.module( 'itxApp.catalog').component('categoryToolbar', CategoryToolbarCmp);

    CategoryToolbarCmpCtrl.$inject = [
        '$scope',
        'ItxCategoryLayoutSvc',
        'ItxFiltersManagerSvc',
        'ItxScreenSizeSvc',
        'categoryTreeSvc',
        'mdUtils'
    ];

    function CategoryToolbarCmpCtrl(
        $scope, 
        ItxCategoryLayoutSvc, 
        ItxFiltersManagerSvc, 
        ItxScreenSizeSvc, 
        categoryTreeSvc,
        mdUtils
    ) {

        var _this = this;
        _this.isMobile = false;
        
        _this.crumbs = [];
        _this.ItxFiltersManagerSvc =  ItxFiltersManagerSvc;
        _this.$onInit = function () {
           _this.isMobile = ItxScreenSizeSvc.isMobile();
            _this.hasExpanded = ItxCategoryLayoutSvc.isExpanded();  
        };
        
        _this.$onChanges = function(c) {
            if(c.category && c.category.currentValue != c.category.previousValue){
                categoryTreeSvc.getFamilyCurrentCategory()
                    .then(function (objFamilyId) {
                        _this.parseCrumbs(objFamilyId);
                    });
            }
        };

        _this.setCollapsed = () => {
            ItxCategoryLayoutSvc.setCollapsed();
            _this.hasExpanded = false;
            _this.onUpdateLayout();
        };

        _this.setExpanded = () => {
            ItxCategoryLayoutSvc.setExpanded();
            _this.hasExpanded = true;
            _this.onUpdateLayout();
        };

        $scope.reloadFilters = function(){            
            _this.onNewFilters();
        };

        _this.parseCrumbs = (obj) => {
            let crumbs = [];
            crumbs.push({name: mdUtils.firstCapitalLetter(obj.section.name) });            
            if(obj.grandmotherCategory.name){
                crumbs.push({name: mdUtils.firstCapitalLetter(obj.grandmotherCategory.name) });
            }
            if(obj.parentCategory.name){
                crumbs.push({name: mdUtils.firstCapitalLetter(obj.parentCategory.name) });
            }
            if(obj.category.name){
                crumbs.push({name: mdUtils.firstCapitalLetter(obj.category.name) });
            }
            _this.crumbs = crumbs;
        };
    
    }

})();

